import React from 'react';
import CoverImageSecond from './CoverImageSecond';
import Service5 from './Service5';
import Service5Second from './Service5Second';
import ReservationForm from './ReservationForm';



import Footer from './Footer';


const Dayouting = () => {
    return (
        <div>
            <CoverImageSecond />
            <Service5 />
            <Service5Second />
            <ReservationForm />


            <Footer/>

        </div>
    );
};

export default Dayouting ;